module.exports = __webpack_public_path__ + "static/media/w (39).d28c7998.jpg";